import { useState } from 'react';
import { Button, Modal } from '@immo/ui-kit';
import { apiClient } from '@/lib/auth/api-client';
import { useTranslations } from '@/i18n/use-translations';

type Props = {
  readonly onClose: () => void;
  readonly onDone: () => void;
};

export function RevokeTokenDialog({ onClose, onDone }: Props) {
  const t = useTranslations('pages.admin.valuation-agent');
  const tIssue = useTranslations('pages.admin.mcp-access.issue');
  const [submitting, setSubmitting] = useState(false);

  const confirm = async () => {
    setSubmitting(true);

    try {
      const result = await apiClient.adminValuationAgentToken.revoke({ body: {} });

      if (result.ok) {
        onDone();

        return;
      }
    } catch {
      // The dialog stays open so the operator can try again.
    }

    setSubmitting(false);
  };

  return (
    <Modal
      open
      onClose={onClose}
      size="sm"
      title={t('revoke-dialog.title')}
      footer={
        <>
          <Button variant="ghost" type="button" onClick={onClose} disabled={submitting}>
            {tIssue('cancel-cta')}
          </Button>
          <Button variant="danger" type="button" onClick={confirm} disabled={submitting}>
            {t('revoke-dialog.confirm')}
          </Button>
        </>
      }
    >
      <p className="text-base-sm text-text-secondary">{t('revoke-dialog.body')}</p>
    </Modal>
  );
}
